module.exports = __webpack_public_path__ + "story-picture.jpg?0b70e4734c1a896bd7eb85b6b3d135bd";